// Kuvr Case Study — Timeline, Gallery, FAQ
// Works on standalone page AND inside kuvr-modal

function initCaseStudy() {
  // Force all lazy images to load (Shopify auto-adds loading=lazy which breaks modal context)
  document.querySelectorAll('.case-study img[loading="lazy"]').forEach(function(img) {
    img.removeAttribute('loading');
    // Force reload by resetting src
    var src = img.src;
    img.src = '';
    img.src = src;
  });

  var fill = document.getElementById('timelineFill');
  var wrap = document.getElementById('timelineWrap');
  
  if (fill && wrap && !wrap.dataset.csInit) {
    wrap.dataset.csInit = '1';
    
    var currentHeight = 0;
    var targetHeight = 0;
    var rafId = null;
    var LERP = 0.15;
    var steps = wrap.querySelectorAll('.step');
    var markers = wrap.querySelectorAll('.step__marker');

    // Detect modal context
    var scrollContainer = wrap.closest('.kuvr-modal__content') || null;
    var isInModal = !!scrollContainer;

    /* Takeover-mode fix, 2026-08-21. BUG-021 (2026-08-10) made the MOBILE modal use
       "takeover mode": the page content is display:none'd and the DOCUMENT scrolls
       (html.kuvr-takeover). .kuvr-modal__content still exists but never scrolls and has
       unconstrained height — so binding to it froze the timeline: the initial fill calc
       used the ~full content height as the viewport (progress = 1, line pre-filled) and
       the IntersectionObserver root contained every step at once (all revealed, no
       stagger). In takeover the layout is identical to the standalone page, so treat it
       as standalone: window scroll + viewport-rooted observer. Desktop modal (>768px,
       no takeover) keeps the container-based path unchanged. */
    if (document.documentElement.classList.contains('kuvr-takeover')) {
      scrollContainer = null;
      isInModal = false;
    }

    function getLivePositions() {
      if (!markers.length) return null;
      var firstRect = markers[0].getBoundingClientRect();
      var lastRect = markers[markers.length - 1].getBoundingClientRect();
      var wrapRect = wrap.getBoundingClientRect();
      var firstCentre = firstRect.top + firstRect.height / 2 - wrapRect.top;
      var lastCentre = lastRect.top + lastRect.height / 2 - wrapRect.top;
      var dotDistance = Math.max(1, lastCentre - firstCentre);
      var firstAbs = firstRect.top + firstRect.height / 2;
      var lastAbs = lastRect.top + lastRect.height / 2;
      return { firstCentre: firstCentre, dotDistance: dotDistance, firstAbs: firstAbs, lastAbs: lastAbs };
    }

    function getTargetHeight() {
      var pos = getLivePositions();
      if (!pos) return 0;
      wrap.style.setProperty('--tl-start', pos.firstCentre + 'px');
      wrap.style.setProperty('--tl-length', pos.dotDistance + 'px');
      fill.style.top = pos.firstCentre + 'px';

      // For modal: use the modal container's visible area instead of window
      var viewportBottom;
      if (isInModal) {
        var containerRect = scrollContainer.getBoundingClientRect();
        viewportBottom = containerRect.top + containerRect.height * 0.75;
      } else {
        viewportBottom = window.innerHeight * 0.75;
      }

      var progress = Math.max(0, Math.min(1,
        (viewportBottom - pos.firstAbs) / (pos.lastAbs - pos.firstAbs)
      ));
      return progress * pos.dotDistance;
    }

    function animate() {
      targetHeight = getTargetHeight();
      var diff = targetHeight - currentHeight;
      if (Math.abs(diff) > 0.5) {
        currentHeight += diff * LERP;
        fill.style.height = currentHeight + 'px';
        rafId = requestAnimationFrame(animate);
      } else {
        currentHeight = targetHeight;
        fill.style.height = currentHeight + 'px';
        rafId = null;
      }
    }

    function onScroll() {
      if (!rafId) { rafId = requestAnimationFrame(animate); }
    }

    // Attach scroll listener to the right element
    if (isInModal) {
      scrollContainer.addEventListener('scroll', onScroll, {passive: true});
    } else {
      window.addEventListener('scroll', onScroll, {passive: true});
    }

    // IntersectionObserver
    var observerOptions = isInModal
      ? { root: scrollContainer, rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      : { rootMargin: '0px 0px -8% 0px', threshold: 0.08 };

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-active');
          } else if (e.boundingClientRect.top > 0) {
            e.target.classList.remove('is-active');
          }
        });
      }, observerOptions);
      steps.forEach(function(s) { io.observe(s); });
    } else {
      steps.forEach(function(s) { s.classList.add('is-active'); });
    }

    // Initial calculation
    currentHeight = getTargetHeight();
    fill.style.height = currentHeight + 'px';
  }

  // Lazy background images
  document.querySelectorAll('.kuvr-bg-img').forEach(function(el) {
    var src = el.getAttribute('data-src');
    if (src) { el.style.backgroundImage = 'url("' + src + '")'; }
  });

  // Gallery carousel
  var track = document.getElementById('kuvrTrack');
  if (track && !track.dataset.initialized) {
    track.dataset.initialized = '1';
    var slides = Array.from(track.children);
    var n = slides.length;
    slides.forEach(function(s) { track.appendChild(s.cloneNode(true)); });
    
    var slideEl = track.children[0];
    var slideWidth = slideEl ? slideEl.offsetWidth + 10 : 310; // 10 = margin-right
    var currentIndex = 0;
    function advance() {
      currentIndex++;
      track.style.transition = 'transform 800ms ease';
      track.style.transform = 'translateX(' + (-currentIndex * slideWidth) + 'px)';
      if (currentIndex === n) {
        setTimeout(function() {
          track.style.transition = 'none';
          track.style.transform = 'translateX(0)';
          currentIndex = 0;
        }, 830);
      }
    }
    setInterval(advance, 1800);
  }

  // FAQ expandable animation + arrow
  document.querySelectorAll('.cs-faq-item').forEach(function(details) {
    if (details.dataset.initialized) return;
    details.dataset.initialized = '1';
    var summary = details.querySelector('summary');
    var content = details.querySelector('summary + div');
    var arrowSpan = details.querySelector('.cs-faq-arrow');
    if (!summary || !content) return;

    if (arrowSpan && !arrowSpan.querySelector('svg')) {
      arrowSpan.innerHTML = '<svg viewBox="0 0 24 24" style="width:100%;height:100%;transition:transform 0.3s;transform:rotate(-90deg);transform-origin:center" fill="none" stroke-width="2"><polyline points="6 9 12 15 18 9" fill="#000" stroke="none"></polyline></svg>';
    }

    var wrapper = document.createElement('div');
    wrapper.style.overflow = 'hidden';
    wrapper.style.transition = 'max-height 0.35s ease';
    wrapper.style.maxHeight = details.open ? content.scrollHeight + 'px' : '0';
    content.parentNode.insertBefore(wrapper, content);
    wrapper.appendChild(content);

    summary.addEventListener('click', function(e) {
      e.preventDefault();
      if (details.open) {
        wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
        wrapper.getBoundingClientRect();
        wrapper.style.maxHeight = '0';
        if (arrowSpan) arrowSpan.querySelector('svg').style.transform = 'rotate(-90deg)';
        setTimeout(function() { details.open = false; }, 350);
      } else {
        details.open = true;
        wrapper.style.maxHeight = '0';
        requestAnimationFrame(function() {
          wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
        });
        if (arrowSpan) arrowSpan.querySelector('svg').style.transform = 'rotate(0deg)';
      }
    });
  });
}

// Run on page load
initCaseStudy();

// Re-run when modal content is injected
(function() {
  // Watch modal content container for changes
  function watchModal() {
    var modalContent = document.getElementById('kuvrModalContent');
    if (!modalContent) return;
    var observer = new MutationObserver(function() {
      if (modalContent.querySelector('.case-study')) {
        setTimeout(initCaseStudy, 300);
      }
    });
    observer.observe(modalContent, { childList: true });
  }

  // Also intercept fetch to catch modal content loads
  var origFetch = window.fetch;
  window.fetch = function() {
    return origFetch.apply(this, arguments).then(function(response) {
      setTimeout(function() {
        var mc = document.getElementById('kuvrModalContent');
        if (mc && mc.querySelector('.case-study')) {
          initCaseStudy();
        }
      }, 500);
      return response;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchModal);
  } else {
    watchModal();
  }
})();
